import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useNavigate, Outlet } from 'react-router-dom'
import { Box, List } from '@mui/material'
import { ListGroup } from 'react-bootstrap'
import { useAuth0 } from '@auth0/auth0-react'

import Appbar from './components/Appbar'
import DrawerMenu  from './components/DrawerMenu'

import LoadingScreen from 'Shared/Components/LoadingScreen'
import { NotifyToast } from 'Shared/Components/NotifyToast'
import useAuth from 'Shared/Hooks/useAuth'
import useWindowSize from 'Shared/Hooks/useWindowSize'
import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'

const Portal = () => {
  const { i18n } = useTranslation()
  const { user } = useAuth0()
  const { organization, project } = useParams()
  const { send } = useFetchData()
  const windowSize = useWindowSize()
  const navigate = useNavigate()
  const { profile, role } = useAuth()

  const drawerWidth = { "xs": 80, "lg": 280 }
  const appbarHeight = 60
  const [collapse, setCollapse] = useState()

  const [userMetaData, setUserMetaData] = useState()
  const [projects, setProjects] = useState()
  const [projectInfo, setProjectInfo] = useState()
  const [loading, setLoading] = useState(false)
  const [reloading, setReloading] = useState(false)

  const [alertTypes, setAlertTypes] = useState({})
  const [alertEvents, setAlertEvents] = useState({})

  useEffect(() => {
    const getTypeTranslations = async () => {
      const body = await send({
        method: "GET",
        url: `${apiUrl}/alert/alert_types`,
        returnType: "json"
      })
    
      setAlertTypes(body)
    }
      
    const getEventTranslations = async () => {
      const body = await send({
        method: "GET",
        url: `${apiUrl}/alert/alert_events`,
        returnType: "json"
      })
    
      setAlertEvents(body)
    }

    const init = async () => {
      setReloading(true)

      await Promise.all([
        send({ url: `${apiUrl}/user/user_metadata`, method: "GET", returnType: "json" }).then(res =>{
          if (res) {
            setProjects(res["permission"])
            setUserMetaData(res["user_metadata"])
          } 
        }),
        getTypeTranslations(),
        getEventTranslations()
      ])

      setReloading(false)
    }

    if (organization == null) {
      navigate(`/portal/${user.org_name}`)
    }

    init()
  }, [])

  useEffect(() => {
    if (windowSize["width"] < 960) {
      setCollapse(true)
    }
    else {
      setCollapse(false)
    }
  }, [windowSize])

  useEffect(() => {
    const getProject = async () => {
      await Promise.all([
        send({ url: `${apiUrl}/user/project_info`, method: "GET", returnType: "json", params: { "project": project } }).then(res =>
          res && setProjectInfo(res)
        ),
      ])
    }

    const init = async () => {
      setReloading(true)

      if (project) {
        await getProject()
      }

      setReloading(false)
    }
    
    init()
  }, [project])

  const reload = async () => {
    setReloading(true)

    setTimeout(async function()  {
      setReloading(false)
    }, 2000)
  }

  const setPageLoading = (value) => {
    setLoading(value)
  }

  return (<>
    {!reloading &&
      <Box sx={{ display: 'flex', flexDirection: 'column'}}>
        {organization && <>
          <Appbar mode={"portal"} title={(project && projectInfo) ? projectInfo[i18n.language.toLowerCase()] : ""} appbarHeight={appbarHeight} userMetaData={userMetaData} projectInfo={projectInfo} projects={projects} setAppbarLoading={setPageLoading} reload={reload}/>

          <Box sx={{ height: windowSize["height"]-appbarHeight }}>
            {(project != null && project != "" && projectInfo != null) ? (
              <Box sx={{ display: 'flex', height: "100%"}}>
                <DrawerMenu mode={"portal"} collapse={collapse} setCollapse={setCollapse} windowSize={windowSize} appbarHeight={appbarHeight} drawerWidth={drawerWidth} projectInfo={projectInfo} />

                <Box sx={{ flex: 1, height: "100%", overflow: "auto", backgroundColor: "#F2F2F2", padding: "15px" }}>
                  <Outlet context={{ projectInfo, alertTypes, alertEvents, role, profile, setPageLoading, windowSize }}/>
                </Box>
              </Box>
            ) : (
              <Box sx={{ width: windowSize["width"], height: "100%", overflow: "auto" }}>
                <List style={{ padding: "0px" }}>
                  <ListGroup variant="flush">
                    {(projects ?? []).map((i) => 
                      <ListGroup.Item key={i["project_code"]} className="border-0" action onClick={() => navigate(`/portal/${organization}/${i["project_code"]}`)}>
                        {`${i[i18n.language.toLowerCase().substring(0, 2)]}`}
                      </ListGroup.Item>
                    )}
                  </ListGroup>
                </List>
              </Box>
            )}
          </Box>
        </>}
      </Box>
    }

    <LoadingScreen isOpen={loading || reloading} />

    <NotifyToast/>
  </>)
}

export default Portal
